/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import { FaHandHolding } from 'react-icons/fa';
import cometList from '../../../../Fct/plugins/compoundv3/helpers/cometList.json';
export var BorrowBalanceOf = createPlugin({
    protocol: 'COMPOUND_V3',
    type: 'GETTER',
    method: 'borrowBalanceOf',
    description: 'Returns the current balance of borrowed base asset for a specified account in the protocol, including interest.',
    supportedContracts: cometList,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                account: new FctAddress({ isPreview: true, icon: FaHandHolding }),
            },
        },
        output: { balance: new FctValue({ innerIndex: 0, isPreview: true }) },
    }); },
});
